import { render, staticRenderFns } from "./CardVideo.vue?vue&type=template&id=60f8c27a&scoped=true&"
import script from "./CardVideo.vue?vue&type=script&lang=js&"
export * from "./CardVideo.vue?vue&type=script&lang=js&"
import style0 from "./CardVideo.vue?vue&type=style&index=0&id=60f8c27a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f8c27a",
  null
  
)

export default component.exports